import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiNotifyUserContentRequestBody,
  IApiNotifyUserContentResponseBody,
} from '../UserContentApi.types';
import { useApi } from '~/lib/api/useApi';
import { userGeneratedContentQueryKeyFactory } from './useUserContentQuery';

export type IUseNotifyUserContentMutationValues = {
  appId: string;
  contentId: string;
  body: IApiNotifyUserContentRequestBody;
};

export const useNotifyUserContentMutation = (): UseMutationResult<
  IApiNotifyUserContentResponseBody,
  unknown,
  IUseNotifyUserContentMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseNotifyUserContentMutationValues) =>
      api.userContent.notify(values.appId, values.contentId, values.body),
    onSuccess: async (_, values) => {
      await queryClient.invalidateQueries({
        queryKey: userGeneratedContentQueryKeyFactory({
          appId: values.appId,
        }),
      });
    },
  });
};
